/* eslint-disable @typescript-eslint/no-explicit-any */
export const getRowToExpand = (expanded, prevExpanded) => {
    if (!prevExpanded)
        return null;
    const ids = Object.keys(expanded);
    if (ids.length < 2)
        return null;
    const rowToExpand = ids.find(id => !(id in prevExpanded));
    return rowToExpand || null;
};
//# sourceMappingURL=getRowToExpand.js.map